/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Embed_Complete_LogInputs */



/**
* | output |
* | --- |
* | "-----Embedding closed caption process complete-----" |
*
* @param {Drastic_Tech_Embed_Complete_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_embed_complete_log = /** @type {((inputs?: Drastic_Tech_Embed_Complete_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Embed_Complete_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("-----Processus d'integration termine-----")
	if (locale === "de") return /** @type {LocalizedString} */ ("-----Einbettung der Untertitel abgeschlossen-----")
	if (locale === "it") return /** @type {LocalizedString} */ ("-----Processo di incorporamento dei sottotitoli completato-----")
	if (locale === "ru") return /** @type {LocalizedString} */ ("-----Процесс встраивания субтитров завершен-----")
	if (locale === "es") return /** @type {LocalizedString} */ ("-----Proceso de incrustación de subtítulos completo-----")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("-----嵌入字幕过程完成-----")
	if (locale === "ja") return /** @type {LocalizedString} */ ("-----字幕埋め込み処理が完了しました-----")
	if (locale === "hi") return /** @type {LocalizedString} */ ("-----क्लोज्ड कैप्शन एम्बेड करने की प्रक्रिया पूरी हो गई-----")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("-----Processo de incorporação de legendas concluído-----")
	return /** @type {LocalizedString} */ ("-----Embedding closed caption process complete-----")
});